import React, { Component } from 'react';

import { BoxContentCounter }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

const accountants = [
    {col: 'col-6 col-md-3 col-lg-3', img:'product', title: 'Produtos', n: 500, plus: true, duration: 7},
    {col: 'col-6 col-md-3 col-lg-3', img:'clients', title: 'Clientes', n: 5000, plus: true, duration: 5},
    {col: 'col-6 col-md-3 col-lg-3', img:'certified', title: 'Certificados', n: 10, plus: false, duration:9 },
    {col: 'col-6 col-md-3 col-lg-3', img:'team', title: 'Colaboradores', n: 30, plus: true, duration: 8 },
];

class Counter extends Component {
    render() {
        return (
            <section className={isMobile ? 'home-counter-mobile' : 'home-counter'}>
                <div className="container">
                    <div className="row">
                        {accountants.map((item,key) => { return BoxContentCounter(item,key) } )}
                    </div>                 
                </div>
            </section>
        )
    }
}

export default Counter;
